<button type="button" class="btn-template"
        [ngClass]="{'btn-solid' : btnStyle === 'Solid','btn-outline' : btnStyle === 'Outline','btn-disabled' : btnStyle === 'Disabled'}">

    <!-- Long Button -->
    <span *ngIf="btnType === 'Long' && btnAction !== 'Custom'" class="btn-center btn-long"
          [ngClass]="{'red': btnAction === 'Remove' || btnAction ==='Close' || btnAction === 'Back'|| btnAction === 'Cancel',
          'green' : btnAction === 'Add' || btnAction === 'Save',
          'yellow': btnAction === 'Edit'}">

        <!-- Add::Button -->
        <div *ngIf="btnAction === 'Add'">
            <i class="fas fa-plus mr-3"></i>
            Add
        </div>

        <!-- Edit::Button -->
        <div *ngIf="btnAction === 'Edit'">
            <i class="fas fa-pen mr-3"></i>
            Edit
        </div>

        <!-- Save::Button -->
        <div *ngIf="btnAction === 'Save'">
            <i class="fas fa-save mr-3"></i>
            Save
        </div>

        <!-- Back::Button -->
        <div *ngIf="btnAction === 'Back'">
            <i class="fas fa-arrow-left mr-3"></i>
            Back
        </div>

        <!-- Close::Button -->
        <div *ngIf="btnAction === 'Close'">
            <i class="fas fa-times mr-3"></i>
            Close
        </div>

        <!-- Remove::Button -->
        <div *ngIf="btnAction === 'Remove'">
            <i class="fas fa-trash-alt mr-3"></i>
            Remove
        </div>
        <!-- Cancel::Button -->
        <div *ngIf="btnAction === 'Cancel'">
            <i class="fas fa-trash-alt mr-3"></i>
            Cancel
        </div>
    </span>

    <!-- Short Button Only -->
    <span *ngIf="btnType === 'Short' && btnAction !== 'Custom'" class="btn-center btn-short"
          [ngClass]="{
          'red': btnAction === 'Remove' || btnAction ==='Close' || btnAction === 'Back',
          'green' : btnAction === 'Add' || btnAction === 'Save','yellow': btnAction === 'Edit',
          'black': btnAction === 'Block'}">
        <i *ngIf="btnAction === 'Add'" class="fa fa-plus"></i>
        <i *ngIf="btnAction === 'Edit'" class="fa fa-pen"></i>
        <i *ngIf="btnAction === 'Save'" class="fa fa-save"></i>
        <i *ngIf="btnAction === 'Back'" class="fa fa-arrow-left"></i>
        <i *ngIf="btnAction === 'Close'" class="fa fa-times"></i>
        <i *ngIf="btnAction === 'Remove'" class="fa fa-trash-alt"></i>
    </span>

    <!-- Table Button -->
    <span *ngIf="btnType === 'Table' && btnAction !== 'Custom'" class="btn-center btn-table"
          [ngClass]="{
          'main' : btnAction === 'View',
          'green' : btnAction === 'Add' || btnAction === 'Save',
          'red': btnAction === 'Remove' || btnAction ==='Close' || btnAction === 'Back',
          'yellow': btnAction === 'Edit','black': btnAction === 'Block'
          }">

        <i *ngIf="btnAction === 'View'" class="far fa-eye"></i>
        <i *ngIf="btnAction === 'Add'" class="fas fa-plus"></i>
        <i *ngIf="btnAction === 'Edit'" class="fas fa-pen"></i>
        <i *ngIf="btnAction === 'Save'" class="fas fa-save"></i>
        <i *ngIf="btnAction === 'Back'" class="fas fa-arrow-left"></i>
        <i *ngIf="btnAction === 'Close'" class="fas fa-times"></i>
        <i *ngIf="btnAction === 'Remove'" class="fas fa-trash-alt"></i>
        <i *ngIf="btnAction === 'Block'" class="fas fa-user-slash"></i>
        <i *ngIf="btnAction === 'Whitelist'" class="fas fa-user-slash"></i>
    </span>


    <!-- Long Button - Custom -->
    <span *ngIf="btnType === 'Long' && btnAction === 'Custom'"
          class="btn-center btn-long {{color}}"
          [ngClass]="{color : btnAction === 'Custom'}">

        <div *ngIf="btnAction === 'Custom'">
            <i *ngIf="!textOnly" class="{{icon}} mr-3"></i>
            {{text}}
        </div>
    </span>

    <!-- Short Button Only - Custom -->
    <span *ngIf="btnType === 'Short' && btnAction === 'Custom'" class="btn-center btn-short {{color}}"
          [ngClass]="{color: btnAction === 'Custom'}">
        <i *ngIf="btnAction === 'Custom'" class="{{icon}}"></i>
    </span>

    <!-- Table Button - Custom -->
    <span *ngIf="btnType === 'Table' && btnAction === 'Custom'"
          class="btn-center btn-table {{color}}"
          [ngClass]="{color : btnAction === 'Custom'}">
        <i *ngIf="btnAction === 'Custom'" class="{{icon}}"></i>
    </span>

</button>
